import * as React from 'react';
import { Box, Paper, Theme, Typography, createStyles, makeStyles } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      minHeight: 300,
      maxWidth: 380,
      padding: theme.spacing(2),
      display: 'flex',
      flexDirection: 'column'
    },
    titleLogo: {
      display: 'flex',
      alignItems: 'center'
    },
    title: {
      fontSize: 10,
      fontWeight: theme.typography.fontWeightMedium,
      letterSpacing: '1.5px',
      textTransform: 'uppercase'
    },
    price: {
      fontSize: 12,
      fontWeight: theme.typography.fontWeightMedium,
      marginLeft: 5,
      letterSpacing: '0.4px'
    },
    description: {
      marginTop: theme.spacing(2)
    },
    requirementDescription: {
      fontWeight: theme.typography.fontWeightMedium
    },
    requirement: {
      display: 'flex',
      fontWeight: theme.typography.fontWeightMedium
    },
    priceDescription: {
      fontWeight: theme.typography.fontWeightMedium,
      marginTop: theme.spacing(2)
    },
    icon: {
      color: 'var(--green)',
      fontSize: theme.spacing(2),
      marginRight: 3
    }
  })
);

export const EssentialsBundleCard: React.FC = () => {
  const { t } = useTranslation('subscriber');
  const classes = useStyles();

  const REQUIREMENTS = [
    t('onlineTraining.requirements.CDM', 'CDM (2015) Awareness'),
    t('onlineTraining.requirements.fire', 'Fire Safety'),
    t('onlineTraining.requirements.health', 'Health Safety'),
    t('onlineTraining.requirements.hazardous', 'Hazardous Substances (COSHH)'),
    t('onlineTraining.requirements.noise', 'Noise'),
    t('onlineTraining.requirements.manual', 'Manual Handling'),
    t('onlineTraining.requirements.near', 'Near Miss Reporting'),
    t('onlineTraining.requirements.PPE', 'PPE'),
    t('onlineTraining.requirements.working', 'Working at Height'),
    t('onlineTraining.requirements.basic', 'Basic First Aid at Work')
  ];

  return (
    <Paper classes={{ root: classes.container }}>
      <Typography variant="h6" classes={{ root: classes.title }}>
        {t('onlineTraining.card.title', 'Recommended')}
      </Typography>
      <Typography variant="h5">{t('onlineTraining.card.subTitle', 'CHAS Essentials Bundle')}</Typography>
      <Typography variant="h5">
        {t('onlineTraining.card.recomendedPrice', '£95')}
        <span className={classes.price}>{t('onlineTraining.card.price', 'per trainee')}</span>
      </Typography>
      <Box className={classes.description}>
        <Typography variant="caption" classes={{ root: classes.requirementDescription }}>
          {t(
            'onlineTraining.card.description',
            'The essential 10-course online training bundle covers all core requirements for an operative:'
          )}
        </Typography>
        {REQUIREMENTS.map((item, index) => (
          <Typography variant="caption" key={index} classes={{ root: classes.requirement }}>
            <CheckIcon classes={{ root: classes.icon }} />
            {item}
          </Typography>
        ))}
      </Box>
      <Typography variant="caption" classes={{ root: classes.priceDescription }}>
        {t(
          'onlineTraining.card.priceDescription',
          'Usual price for all listed is £260.00 + VAT per trainee. CHAS member pricing £95.00 + VAT per trainee.'
        )}
      </Typography>
    </Paper>
  );
};
